/**
 * Created by Languagenut on 10/09/2019.
 */


import React  from 'react';
import {Button , Card , Row , Col , Navbar , Nav} from 'react-bootstrap'
import FieldGroup from '../FieldGroup.js';
import GoogleImages from 'google-images';
import VocabularyGenerator from '../classes/vocabulary_generator.js';
import Config from '../../classes/config.js';
import PicturePopup from '../../components/popup/information_popup.js';
import Comfirmation from '../../components/popup/comfirmation_popup.js'
import ImageUploader from 'react-images-upload';
import Recorder from '../../components/vocabRecorderUploader.js'
import Package from '../../classes/package.js';
import Translation from '../../store/internationalization-store.js'

export default class VocabularyBlock extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        console.log(this.props)
        this.state = {
            learningRecording:false,
            learning : props.learning ? props.learning.text : '',
            support : props.support ? props.support.text : '',
            picture : '',
            images:{},
            learningAssets:{
                word:props.learning ? props.learning.text : '',
                picture:this.props.picture || {},
                sound:this.props.learningAudio || {}
            },
            supportAssets:{
                word:props.support ? props.support.text : '',
                picture:this.props.picture || {},
                sound:this.props.supportAudio || {}
            },
            incorrect:props.incorrect,
            comfirmation_popup:false,
            word:'bonjour',
            recordingType:'learning',

        };

        console.log(this.state)
    }

    componentDidUpdate(){
        this.onUpdate();
    }

    componentWillReceiveProps(props){

        if(props.languageIETF != this.props.languageIETF)
        {
            if(this.state.learning)
                if(this.state.learning.length >= 1)
                {
                    (new VocabularyGenerator()).getVocabulary(this.state.learning , props.languageIETF , props.supportIETF).then(function(assets){

                        console.log(assets)
                        this.setState({

                            learningAssets:assets
                        })
                    }.bind(this))
                }
        }

        if(props.supportIETF != this.props.supportIETF)
        {
            if(this.state.support)
                if(this.state.support.length >= 1)
                {
                    (new VocabularyGenerator()).getVocabulary(this.state.support , props.supportIETF , props.languageIETF).then(function(assets){


                        this.setState({

                            supportAssets:assets
                        })

                    }.bind(this))
                }
        }

        this.props = props
        this.setState({update:true, incorrect:props.incorrect})
    }

    componentDidMount(){
        if(this.state.learning)
        if(this.state.learning.length >= 1 && !this.props.blockInit)
        {
            (new VocabularyGenerator()).getVocabulary(this.state.learning , this.props.languageIETF , this.props.supportIETF).then(function(assets){

                this.setState({
                    learningAssets:assets
                })
            }.bind(this))
        }

        if(this.state.support)
        if(this.state.support.length >= 1 && !this.props.blockInit)
        {
            (new VocabularyGenerator()).getVocabulary(this.state.support , this.props.supportIETF , this.props.languageIETF).then(function(assets){


                this.setState({

                    supportAssets:assets
                })

            }.bind(this))
        }

        this.onUpdate();
    }

    onDeleted(){
        if(this.props.onDeleted) this.props.onDeleted(this.props.index);
    }

    onChangeInput(event , type){
        const self = this;

        if (self.state[type+'typingTimeout']) {
            clearTimeout(self.state[type+'typingTimeout']);
        }

        switch(type)
        {
            case  'learning' :
                self.setState({
                    learning: event.target.value,
                    incorrect:false,
                    typing: false,
                    learningtypingTimeout: setTimeout(function () {
                        (new VocabularyGenerator()).getVocabulary(this.state.learning , this.props.languageIETF , this.props.supportIETF).then(function(assets){

                            this.setState({
                                learningAssets:assets
                            })
                        }.bind(this))
                    }.bind(this), 1000)
                });
                break;

            case  'support'  :
                self.setState({
                    support: event.target.value,
                    typing: false,
                    incorrect:false,
                    supporttypingTimeout: setTimeout(function () {
                        (new VocabularyGenerator()).getVocabulary(this.state.support , this.props.supportIETF , this.props.languageIETF).then(function(assets){


                            this.setState({
                                 supportAssets:assets
                            })

                        }.bind(this))
                    }.bind(this), 1000)
                });
                break;
        }
    }

    hasPicture(){


        if(this.state.userImageDataUrl)
        {
            return true
        }

        console.log(this.state.learningAssets)
        if(this.state.learningAssets.picture)
        {
            console.log(this.state.learningAssets.picture)
            if(this.state.learningAssets.picture.available){
                console.log(this.state.learningAssets.picture.available)
                return this.state.learningAssets.picture.available
            }
        }

        if(this.state.supportAssets.picture)
        {
            if(this.state.supportAssets.picture.available){
                return this.state.supportAssets.picture.available
            }
        }

        return false

    }


    isPictureDataUrl(){

        if(this.state.userImageDataUrl)
        {
            return true
        }


        return false
    }

    getPicture(isSave){

        if(this.state.userImageDataUrl)
        {
            return this.state.userImageDataUrl
        }

        if(this.state.learningAssets.picture)
        {
            if(this.state.learningAssets.picture.available){
                return isSave ? this.state.learningAssets.picture.path : Config.getImagePath() + "vocabs/" + this.state.learningAssets.picture.path
            }
        }

        if(this.state.supportAssets.picture)
        {
            if(this.state.supportAssets.picture.available){
                return  isSave ? this.state.supportAssets.picture.path : Config.getImagePath() + "vocabs/" + this.state.supportAssets.picture.path
            }
        }

        return false
    }

    hasAudio(type){

        if(this.state[type + 'SoundUser'])
        {
            return true;
        }


        if(this.state[type + 'Assets'].sound)
        {
            return this.state[type + 'Assets'].sound.available
        }

        return false
    }

    generateAudio(type){


        if(this.state[type + 'Assets'].sound)
        {
            return this.state[type + 'Assets'].sound.generate
        }

        return false
    }

    playAudio(type)
    {
        console.log(this.state)
        if(this.state[type + 'SoundUser'])
        {
            var _audio = new Audio();
            _audio.src = this.state[type + 'SoundUser']
            _audio.play();

            return;
        }

        if(!this.hasAudio(type))
        {
            return;
        }

        if(!this.generateAudio(type))
        {
            var _audio = new Audio();
                _audio.src = Config.getAudioBaseUrl() + this.state[type + 'Assets'].sound.soundPath;
                _audio.play();
            return;
        }

        this.state[type + 'Assets'].sound.soundPath.then(function(path){

            var _audio = new Audio();
                _audio.src = Config.getAudioBaseUrl() + path;
                _audio.play();
        });
    }


    getSoundPath(type){

        return new Promise(function(resolve){


            if(this.state[type + 'SoundUser'])
            {
                return resolve(this.state[type + 'SoundUser'])
            }

            if(!this.hasAudio(type))
            {
                return resolve(false)
            }

            if(!this.generateAudio(type))
            {
                return resolve(this.state[type + 'Assets'].sound.soundPath)
            }


            this.state[type + 'Assets'].sound.soundPath.then(function(path){
                resolve(path)
            });

        }.bind(this))
    }

    onDrop(pictureFiles)
    {
        let reader = new FileReader();
        let file   = pictureFiles[0];

        reader.onloadend = () => {

            this.setState({
                userImageFile: file,
                userImageDataUrl: reader.result,
                upload:false,
                uploadAudio:false,
                preview:true,
            });

            //  this.props.onChange(reader.result);
        };
        if (file != undefined) {
            reader.readAsDataURL(file)
        }
    }

    onUpdate(){

        return Promise.all([this.getSoundPath('learning') , this.getSoundPath('support')]).then(function(configs){
            let config = {
                learning:this.state.learning,
                learningAudio:typeof configs[0] === 'object'? configs[0].soundPath : configs[0],
                support:this.state.support,
                supportAudio:typeof configs[1] === 'object' ?configs[1].soundPath : configs[1],
                picture:this.getPicture(true),
                pictureDataURL :this.isPictureDataUrl(),
            }

            if(this.props.onUpdate) this.props.onUpdate(config , this.props.index);
        }.bind(this));
       
    }
    onChangeHandler(event){
        const reader = new FileReader();
        reader.addEventListener("load", function () {
            // convert image file to base64 string
            this.setState({learningSoundUser:reader.result, uploadAudio:false});
        }.bind(this), false);
        
        if (event.target.files[0]) {
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    render(){


        let preview = null;
        let text = this.hasPicture()  ?  <span onClick={()=>{this.setState({upload:true})}} className="hyperlink">{Translation.get(12629 , 'Change Picture')}</span> :  <span onClick={()=>{this.setState({upload:true})}} className="hyperlink">{Translation.get(12760 , 'Add Picture')}</span>;
        let text_button = this.hasPicture()  ?  <Button onClick={()=>{this.setState({upload:true})}} >{Translation.get(12629 , 'Change Picture')}</Button> :  <Button onClick={()=>{this.setState({upload:true})}} >{Translation.get(12760 , 'Add Picture')}</Button>;
        let updateAudio =  <Button onClick={()=>{this.setState({uploadAudio:true})}}>{Translation.get(12630 , 'Upload Audio')}</Button>;
        if(this.hasPicture())
        {
            preview = <td>
                <div onClick={()=>{if(this.hasPicture()) { this.setState({preview:true}) } }} class="UploadedImage">
                    <div class="UploadedImage-imageWrap">
                        <div class="ZoomableImage">
                            <img alt="" class="ZoomableImage-rawImage UploadedImage-image" height="50" src={this.getPicture()} width="50"/>
                        </div>
                        <a class="UploadedImage-overlay">
                            <svg aria-label="eye" class="UIIcon UIIcon--eye UploadedImage-overlayIcon" role="img">
                                <noscript></noscript></svg>
                        </a>
                    </div>
                </div>
            </td>
        } else {
            preview = <td>
                <div class="UploadedImage">
                    <div class="UploadedImage-imageWrap">
                        <div alt="" class="ZoomableImage-rawImage UploadedImage-image" style={{width:"70px"}}>{Translation.get(12631 , 'No image available')}</div>
                    </div>
                </div>
            </td>
        }

        if((new Package()).isSecondary())
        {
            preview = null;
            text = null;
        }

        var style = {};
        if (this.state.incorrect) {
            style = {borderColor:"#FF0000"};
        }

        return <div style={{marginBottom:'10px'}}>
            <Card body style={style}>
                <Row>
                    <Comfirmation title={this.state.word} body={<center><b>{Translation.get(12632 , 'Languagenut has an audio/image for this word. Would you like to use that instead?')}</b></center>} show={this.state.comfirmation_popup} onHide={()=>{ this.setState({comfirmation_popup:false})}} />
                    <PicturePopup title={Translation.get(12638 , 'Upload Image')} onHide={()=>{this.setState({upload:false})}} show={this.state.upload}>
                        <ImageUploader
                            withIcon={true}
                            buttonText='Choose Image'
                            onChange={this.onDrop.bind(this)}
                            imgExtension={['.png', '.jpg']}
                            maxFileSize={5242880}
                            />
                    </PicturePopup>
                    <PicturePopup title={'Upload Audio'} onHide={()=>{this.setState({uploadAudio:false})}} show={this.state.uploadAudio}>
                        <input type="file" name="file" onChange={this.onChangeHandler.bind(this)} accept="audio/*"/>
                    </PicturePopup>
                    <PicturePopup title={<center>{this.state.learning}</center>} onHide={()=>{this.setState({preview:false})}} show={this.state.preview}>
                        <center><img height={150} src={this.getPicture()} /></center>
                                <br/>
                        <table width={'100%'}>
                            <tr>
                                <td>
                                    <center><Button onClick={()=>{this.setState({preview:false})}}>{Translation.get(12633 , 'Save Picture')}</Button> </center>
                                </td>
                            </tr>
                        </table>
                        <br/>
                    </PicturePopup> 
                    <PicturePopup onHide={()=>{this.setState({learningRecording:false})}} show={this.state.learningRecording}>
                        <center>
                        <Recorder onHide={()=>{this.setState({learningRecording:false})}} recorded={this.state.recorded} baseFile={this.state.audio} audioPreview={this.path} onSave={(dataURL)=>{ this.setState({hasChanged:true , recorded:true , learningSoundUser:dataURL});}} />
                        </center>
                    </PicturePopup>
                    <PicturePopup onHide={()=>{this.setState({supportRecording:false})}} show={this.state.supportRecording}>
                        <center>
                            <Recorder onHide={()=>{this.setState({supportRecording:false})}} recorded={this.state.recorded} baseFile={this.state.audio} audioPreview={this.path} onSave={(dataURL)=>{ this.setState({hasChanged:true , recorded:true , supportSoundUser:dataURL}); }} />
                        </center>
                    </PicturePopup>
                    <Col md={12}>
                        <table width={'100%'}>
                            <tr>
                                <td colspan={5}>
                                   {text}
                                </td>
                            </tr>
                            <tr>
                                {preview}
                                <td>
                                    <FieldGroup autoFocus={!this.props.edit} placeholder={Translation.get(12634, 'Enter learning word')} help={Translation.get(12761 , 'Learning word')} onChange={(event)=>{ this.onChangeInput(event , 'learning')}} value={this.state.learning} id="student-name"/>
                                </td>
                                <td style={{width:"130px", paddingBottom:"16px"}}>{updateAudio}</td>
                                <td width={'100px'}>
                                    <center style={{ marginTop:'-14px' , padding:'7px', border:'1px solid #cccccc'}} className="menu_shadow mx-auto" bg="light" expand="lg">
                                        <span onClick={this.playAudio.bind(this , 'learning')} ><i class={ this.hasAudio('learning') ? "fas fa-volume-up" : "text-danger fas fa-volume-mute"}></i></span>
                                        &nbsp; &nbsp; &nbsp;|<span class="animated infinite pulse" onClick={()=>{

                                        this.setState({

                                        learningRecording:!this.state.learningRecording
                                        })}} style={{padding:"10px", marginTop:'10px'}}><i class=" fa-1x fas fa-microphone"></i></span>
                                    </center>
                                </td>
                                <td width={'50px'}></td>
                                <td ><FieldGroup placeholder={Translation.get(12635, 'Enter support word')} help={Translation.get(12762 , 'Support word')} onChange={(event)=>{ this.onChangeInput(event , 'support') }} value={this.state.support} id="student-name"/></td>
                                <td width={'100px'}>
                                    <center style={{ marginTop:'-14px' , padding:'7px', border:'1px solid #cccccc'}} className="menu_shadow mx-auto" bg="light" expand="lg">
                                        <span><i  onClick={this.playAudio.bind(this , 'support')} class={ this.hasAudio('support') ? "fas fa-volume-up" : "text-danger fas fa-volume-mute"}></i></span>
                                        &nbsp; &nbsp; &nbsp;|<span onClick={()=>{
                                        this.setState({

                                        supportRecording:!this.state.supportRecording
                                        })}} style={{padding:"10px", marginTop:'10px'}}> <i class="fa-1x fas fa-microphone"></i></span>
                                    </center>
                                </td>
                                <td width={'100px'}>
                                    <div onClick={this.onDeleted.bind(this)} ><center><i style={{position:'relative', top:"-8px", left:"15px"}} class="fa-1x fas fa-trash-alt"></i></center></div>
                                </td>
                            </tr>
                            <tr>

                            </tr>
                        </table>
                    </Col>
                   
                </Row>
            </Card>
        </div>
    }
}